import Reveal from "../components/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

const FAQS = [
  { q: "What services does Codeflare Labs offer?", a: "Website & Mobile App development, E-commerce, CRM/ERP, AI Automation, Digital Marketing, IT Consulting, Blockchain, Custom Software, Telesales and Tele-caller support — 11 verticals in total." },
  { q: "Where are you based and do you serve international clients?", a: "We are headquartered in Kolkata, West Bengal, India. We work with 50+ clients across India, Australia and other regions." },
  { q: "Do you take on Government projects?", a: "Yes. We are an empanelled vendor for the Kolkata Municipal Corporation and welcome enquiries from other Govt bodies." },
  { q: "How can I schedule a meeting?", a: "Use the AI chatbot at the bottom-right of any page — it will collect your details and schedule a slot. You may also email contact@codeflarelabs.com or message us on WhatsApp." },
  { q: "What is your typical project timeline?", a: "Most websites ship in 3–6 weeks, mobile apps in 8–14 weeks, and CRM/ERP builds in 10–20 weeks depending on scope." },
  { q: "Do you offer internships?", a: "Yes — internships are listed on our Career page along with full-time and part-time roles." },
  { q: "Is my data safe when I apply for a job?", a: "All uploaded files (photo, resume, govt ID) are stored securely and accessible only to authorised hiring admins. See our Privacy Policy for full details." },
];

export default function FAQs() {
  return (
    <div data-testid="faqs-page" className="pt-32 pb-20">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <Reveal><span className="text-xs font-bold tracking-[0.25em] text-[#FF6B1A] uppercase">Help Center</span></Reveal>
        <Reveal delay={0.1}><h1 className="mt-4 text-5xl font-bold">Frequently asked <span className="flame-text">questions</span></h1></Reveal>
        <Reveal delay={0.2}>
          <Accordion type="single" collapsible className="mt-10 glass rounded-3xl divide-y divide-white/10">
            {FAQS.map((f, i) => (
              <AccordionItem key={f.q} value={`f-${i}`} className="border-0 px-6">
                <AccordionTrigger className="text-left text-base font-semibold py-5 hover:text-[#FF6B1A]" data-testid={`faq-trigger-${i}`}>
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-zinc-400 text-sm pb-5 leading-relaxed">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </div>
  );
}
